import { ref } from "vue";

import { defineStore } from "pinia";

export const useVersionNotifierStore = defineStore("version-notifier", () => {
  const version = ref<string>("");

  const setVersion = (newVersion: string): void => {
    version.value = newVersion;
  };

  return {
    setVersion,
    version,
  };
});
